var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_c('i',{staticClass:"icon icon-lg icon-checkmark"})]):_c('span',{staticClass:"text-muted"},[_vm._v("\n  —\n")])}
var staticRenderFns = []

export { render, staticRenderFns }